export default __webpack_public_path__ + "static/media/CNo.39-2.75449055.jpg";